import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Intent, TextArea } from "@blueprintjs/core";

TextAreaField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Field value
   */
  value: PropTypes.string,

  /**
   * Triggered when field value is changed
   */
  onValueChange: PropTypes.func,

  /**
   * Triggered when field validity is changed
   */
  onValidityChange: PropTypes.func,

  /**
   * Set as required. If field is set as required an value is NULL then field will be marked as invalid
   */
  required: PropTypes.bool,

  /**
   * Regex to validate field value. If regex fails then the field will be marked as invalid
   */
  regex: PropTypes.string,

  /**
   * Min length of string
   */
  minLength: PropTypes.number,

  /**
   * Max length of string
   */
  maxLength: PropTypes.number,

  /**
   * Set to true to disable this field
   */
  disabled: PropTypes.bool
} : {};

export default function TextAreaField(props) {
  var value = props.value,
      onValueChange = props.onValueChange,
      onValidityChange = props.onValidityChange,
      required = props.required,
      regex = props.regex,
      minLength = props.minLength,
      maxLength = props.maxLength,
      disabled = props.disabled,
      readOnly = props.readOnly,
      displayForm = props.displayForm;

  var _useState = useState(true),
      valid = _useState[0],
      setValid = _useState[1];

  useEffect(function () {
    var invalidRequired = !value && required;
    var invalidkMinLength = minLength && value && value.length < minLength;
    var invalidMaxLength = maxLength && value && value.length > maxLength;
    var myRe = new RegExp(regex);
    var invalidRegex = value ? !myRe.exec(value) : false;
    var isValid = !(invalidRequired || invalidkMinLength || invalidMaxLength || invalidRegex);
    if (isValid != valid) {
      setValid(isValid);
      onValidityChange && onValidityChange(isValid);
    }
  }, [value, valid, required, regex, minLength, maxLength]);

  var handleChange = function handleChange(e) {
    var value = e.target.value;

    onValueChange(value);
  };

  return displayForm ? React.createElement(
    "div",
    { className: "dt-field-value" },
    value
  ) : React.createElement(TextArea, {
    fill: true,
    growVertically: true,
    onChange: handleChange,
    disabled: disabled,
    readOnly: readOnly,
    value: value || "",
    rows: 5,
    intent: valid || !value ? Intent.NONE : Intent.DANGER,
    style: { minHeight: "80px", minWidth: "100%", maxWidth: "100%" }
  });
}